/** Lógica pura do `CampoListaChips`: separar o que foi digitado/colado e acrescentar sem repetir. */

/** Separador padrão: quebra de linha, ponto e vírgula e vírgula (descrições podem ter espaço). */
export const SEPARADOR_PADRAO = /[\n\r;,\t]+/;

export interface ResultadoAcrescimo {
  valores: string[];
  /** Trechos que o `interpretar` não aceitou, como foram digitados. */
  recusados: string[];
  /** Quantos ficaram de fora por passar do máximo. */
  excedentes: number;
}

/** Corta o texto nos separadores, sem pedaços vazios. */
export function separarTrechos(texto: string, separador: RegExp = SEPARADOR_PADRAO): string[] {
  return texto
    .split(separador)
    .map((t) => t.trim())
    .filter((t) => t !== '');
}

/**
 * Acrescenta os trechos à lista: cada um passa pelo `interpretar` (nulo = inválido), repetidos
 * são ignorados e o que passa do `maximo` fica de fora (contado em `excedentes`).
 */
export function acrescentarTrechos(
  atuais: readonly string[],
  trechos: readonly string[],
  interpretar: (texto: string) => string | null,
  maximo: number,
): ResultadoAcrescimo {
  const valores = [...atuais];
  const recusados: string[] = [];
  let excedentes = 0;
  for (const trecho of trechos) {
    const valor = interpretar(trecho);
    if (valor === null) recusados.push(trecho);
    else if (valores.includes(valor)) continue;
    else if (valores.length >= maximo) excedentes++;
    else valores.push(valor);
  }
  return { valores, recusados, excedentes };
}

/** Frase do aviso (região `polite`) para o que não entrou; vazio quando entrou tudo. */
export function avisoDoAcrescimo(
  { recusados, excedentes }: Pick<ResultadoAcrescimo, 'recusados' | 'excedentes'>,
  maximo: number,
): string {
  const partes: string[] = [];
  if (recusados.length > 0) partes.push(`Não aceito: ${recusados.join(', ')}`);
  if (excedentes > 0)
    partes.push(`Máximo de ${String(maximo)} ${maximo === 1 ? 'valor' : 'valores'}`);
  return partes.join('. ');
}
